import template from './trip-item-taxi.html';

const DIRECTIVE_NAME = TripItemTaxi.DIRECTIVE_NAME = 'ktTripItemTaxi';
export default function TripItemTaxi() {
    return {
        restrict: 'A',
        template,
        scope: {
            taxi: `=${DIRECTIVE_NAME}`,
            isCheckout: `=${DIRECTIVE_NAME}IsCheckout`,
        },
        bindToController: true,
        controller: TripItemTaxiController,
        controllerAs: '$ctrl',
        link: function($scope, $elem, $attrs, $ctrl) {
            $ctrl.$onInit();
        },
    };
}

export function TripItemTaxiController(
    userService,
    tripItemTaxiService,
) {
    'ngInject';

    const vm = this;

    Object.assign(vm, {
        $onInit,
    });

    function $onInit() {
        vm.rs = userService.getRegionalSettings();
        vm.fromToRoute = tripItemTaxiService.getFromToRoute(vm.taxi);
        vm.firstStop = tripItemTaxiService.getFirstTaxi(vm.taxi);
        vm.lastStop = tripItemTaxiService.getLastTaxi(vm.taxi);
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/trip/trip-item-taxi/trip-item-taxi.js